module.exports = "/roster/components/rosterEmptyComponent-cb1fcd.html";